import { ColumnDefinitionCategory, DataType } from "."
import { ObjectType, ObjectTypeConfig } from ".."
import { PRODUCT_TYPE } from "../../../product/Types"
import { PREFERENCE_TYPE } from "../../constants"
import productConfiguration, { ProductsColumnIds } from "./products"

const titleIndex = productConfiguration.columnDefinitions.findIndex(def => def.id === ProductsColumnIds.TITLE)

const configuration: ObjectTypeConfig = {
    ...productConfiguration,
    objectType: ObjectType.BUNDLES,
    columnDefinitions: [
        ...productConfiguration.columnDefinitions.slice(0, titleIndex),
        {
            id: ProductsColumnIds.TITLE,
            sortId: "titleKeyword",
            defaultSort: true,
            dataType: DataType.LINK,
            dataAttributes: {
                redirect: "/bundles/edit/{id}",
                secondaryValueKey: ProductsColumnIds.SKU,
            },
            sortable: true,
            identifier: true,
            defaultView: true,
            categories: [ColumnDefinitionCategory.DEFAULT, ColumnDefinitionCategory.PRODUCT_RELATED],
        },
        ...productConfiguration.columnDefinitions.slice(titleIndex + 1),
    ],
    listingPreferencesKey: PREFERENCE_TYPE.LISTING_BUNDLES,
    searchPlaceholder: {
        id: "generic-listing.matrices.search-placeholder",
        defaultMessage: "Search bundles...",
    },
    displayString: {
        id: "generic-listing.matrices.display-string",
        defaultMessage: "Bundles",
    },
    additionalFilters: {
        type: [PRODUCT_TYPE.BUNDLE]
    },
    creationButtonComponent: require("../../../../common/listing/generic-listing/creation-buttons/BundleCreationButton"),
}

export default configuration


// WEBPACK FOOTER //
// ./src/state/listing/generic-listing/column-definitions/bundles.ts